<template>
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-icon="WaitingOutlined"
	>
		<path
			d="M6 7.5v-4H5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1v4c0 2.102-.818 3.316-3.244 4.472C17.182 13.127 18 14.342 18 16.444V20.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1v-4.056c0-2.102.818-3.317 3.244-4.472C6.818 10.816 6 9.602 6 7.5Zm6 3.44c3.332-1.195 4-1.86 4-3.44v-4H8v4c0 1.58.667 2.245 4 3.44Zm-4 5.504V20.5h8v-4.056c0-1.58-.668-2.245-4-3.44-3.333 1.195-4 1.86-4 3.44Z"
			fill="currentColor"
		></path>
	</svg>
</template>
